import { render } from "./GruppeadgangsanmodningList.vue?vue&type=template&id=4a3875e2"
import script from "./GruppeadgangsanmodningList.vue?vue&type=script&lang=js"
export * from "./GruppeadgangsanmodningList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__